import React from 'react';
import { StatusTrackerTable } from '../../../monitoring_report/edit/SubmissionStatusTracker';
import NoDataComponent from '../../../dashboard/no_data_component';
import { useSelector } from 'react-redux';

function WorkflowStatusTrackerWidget({ widgetId }){
  const monitoringReportId = useSelector(state => state.dashboard.widgets[widgetId].settings?.workflow_id);

  return (
    monitoringReportId ?
      <StatusTrackerTable monitoringReportId={monitoringReportId} tableHeight='100%' autoHeight={true} />
    : <NoDataComponent />
  )
}

export default WorkflowStatusTrackerWidget;
